<div class="patient-fax-card d-flex align-items-center">
  <mat-icon class="me-2 md-18">fax</mat-icon>
  <span class="text">
        <span>{{faxNumber}}</span>
    </span>
</div>
